<lx-selector-field-container
  i18n-label
  label="Dates"
  [disabled]="disabled"
  [empty]="!selectedValue"
  [selectorFieldHandler]="openSelectorClickHandler"
  data-qa="flexibleStartDateSelector_field"
>
  <lx-dates [startDate]="selectedStartDate" [endDate]="selectedEndDate" [emptyMsg]="emptySelectionMsg"> </lx-dates>
</lx-selector-field-container>

<lx-side-panel
  i18n-title
  title="Select a start date"
  [visible]="dialogVisible"
  (hiddenPanel)="hideDialog()"
  size="large"
  data-qa="flexibleStartDateSelector_sidePanel"
>
  <lx-calendar-field
    *ngIf="calendarConfig"
    [inline]="true"
    [dateValue]="selectedValue"
    [(ngModel)]="selectedValue"
    (ngModelChange)="handleSelectedDate($event)"
    (yearChanged)="yearChanged.emit($event)"
    [minDate]="calendarConfig?.minDate"
    [defaultDate]="calendarConfig?.minDate"
    [maxDate]="calendarConfig?.maxDate"
    [disabledDates]="calendarConfig?.disabledDates"
    [disclaimer]="disclaimer"
    footerText="Courses start every Monday (Tuesday if a bank holiday)."
    i18n-footerText
    data-qa="flexibleStartDateSelector_calendar"
  ></lx-calendar-field>
</lx-side-panel>
